import * as React from 'react';
import LexiconStemMatch from '../new/lexicons/LexiconStemMatch';
import LexiconStemResult from '../new/lexicons/LexiconStemResult';
import LexiconSearchResultItem from './LexiconSearchResultItem';
import './LexiconSearchResults.css';

interface Props {
    results: LexiconStemResult | null;
    onClick: (match: LexiconStemMatch) => void;
}

export default class LexiconSearchResults extends React.Component<Props> {

    public render() {
        return (
            <div className="LexiconSearchResults">
                {this.props.results && this.props.results.getMatches().map(match =>
                    <LexiconSearchResultItem key={match.getText()} match={match} onClick={this.props.onClick} />
                )}
            </div>
        );
    }
}
